<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <BreadCrumb :data="breadcrumb" :title="'文章详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <DIV v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div style="display: flex; flex-direction: column">
          <div>
            <h4>封面图</h4>
            <img
              v-if="articleDetail.cover_image"
              :src="articleDetail.cover_image"
              alt=""
              class="form-content-img logo"
            />
            <img
              v-else
              src="../../../../static/image/no-img.png"
              alt=""
              class="form-content-img cover"
            />
          </div>
          <div>
            <h4>二维码</h4>
            <img
              v-if="articleDetail.qr_code"
              :src="articleDetail.qr_code"
              alt=""
              class="form-content-img logo"
            />
            <img
              v-else
              src="../../../../static/image/no-img.png"
              alt=""
              class="form-content-img cover"
            />
          </div>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>标题</h4>
            <span>{{ articleDetail.title }}</span>
          </li>
          <!-- <li class="exclusive">
            <h4>ABS</h4>
            <span v-if="articleDetail.abs != null">{{
              articleDetail.abs
            }}</span>
            <span v-if="articleDetail.abs == null">暂无</span>
          </li>
          <li class="exclusive">
            <h4>简介</h4>
            <span v-if="articleDetail.introduce != null">{{
              articleDetail.introduce
            }}</span>
            <span v-if="articleDetail.introduce == null">暂无</span>
          </li> -->
          <li class="exclusive">
            <h4>Abstract</h4>
            <span>{{ articleDetail.abs }}</span>
          </li>
          <li class="exclusive">
            <h4>作者机构</h4>
            <div
              v-for="(item, index) in articleDetail.organization_author_map"
              :key="index"
              class="org_author"
            >
              <div v-for="(value, key, index) in item" :key="index">
                <div>
                  <span v-if="key != 'index'">{{ key }}:</span>
                  <span>{{ value | scholarname }}</span>
                </div>
              </div>
            </div>
          </li>
          <li class="half">
            <h4>分类排序</h4>
            <span v-if="articleDetail.classification_order != null">{{
              articleDetail.classification_order
            }}</span>
            <span v-if="articleDetail.classification_order == null">暂无</span>
          </li>
          <!-- <li class="half">
            <h4>开始时间</h4>
            <span v-if="articleDetail.start_time != null">{{
              articleDetail.start_time
            }}</span>
            <span v-if="articleDetail.start_time == null">暂无</span>
          </li>
          <li class="half">
            <h4>结束时间</h4>
            <span v-if="articleDetail.end_time != null">{{
              articleDetail.end_time
            }}</span>
            <span v-if="articleDetail.end_time == null">暂无</span>
          </li> -->
          <!-- <li class="half">
            <h4>语言</h4>
            <span v-if="articleDetail.language != null">{{
              articleDetail.language
            }}</span>
            <span v-if="articleDetail.language == null">暂无</span>
          </li> -->
          <li class="half">
            <h4>链接</h4>
            <span v-if="articleDetail.link != null">{{
              articleDetail.link
            }}</span>
            <span v-if="articleDetail.link == null">暂无</span>
          </li>
          <!-- <li class="half">
            <h4>地点</h4>
            <span v-if="articleDetail.location != null">{{
              articleDetail.location
            }}</span>
            <span v-if="articleDetail.location == null">暂无</span>
          </li> -->
          <li class="half">
            <h4>history</h4>
            <span v-if="articleDetail.history != null">{{
              articleDetail.history | scholarname
            }}</span>
            <span v-if="articleDetail.history == null">暂无</span>
          </li>
          <li class="half">
            <h4>keywords</h4>
            <span v-if="articleDetail.keywords != null">{{
              articleDetail.keywords | scholarname
            }}</span>
            <span v-if="articleDetail.keywords == null">暂无</span>
          </li>

          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="articleDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </DIV>

    <!-- 修改大学详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>修改信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <h4>封面图</h4>
          <UploadImage
            :img="articleDetail.cover_image"
            :width="150"
            :height="200"
            @getUploadImage="getUploadCoverImage"
            class="form-content-img"
          ></UploadImage>
          <br />
          <h4>二维码</h4>
          <UploadImage
            :img="articleDetail.qr_code"
            :width="150"
            :height="150"
            @getUploadImage="getUploadQrcode"
            class="form-content-img"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>标题</h4>
            <el-input
              v-model="articleDetail.title"
              placeholder="请输入标题"
            ></el-input>
          </li>
          <!-- <li class="exclusive">
            <h4 class="choice">ABS</h4>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入abs"
              v-model="articleDetail.abs"
            >
            </el-input>
          </li>

          <li class="exclusive">
            <h4 class="choice">内容</h4>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="articleDetail.content"
            >
            </el-input>
          </li> -->
          <li class="exclusive">
            <h4 class="choice">机构</h4>
            <div
              class="images-box"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div
                style="
                  border: 1px solid black;
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  font-size: 20px;
                  text-align: center;
                  margin-right: 20px;
                  cursor: pointer;
                "
                @click="addOrganization()"
              >
                +
              </div>
              <div
                class="image-list"
                style="display: flex; flex-direction: column"
              >
                <div
                  class="image-item"
                  v-for="(item, index) in articleDetail.organization"
                  :key="index"
                  style="
                    height: 32px;
                    background-color: #5470c6;
                    color: white;
                    border-radius: 5%;
                    line-height: 32px;
                    text-align: center;
                    margin-bottom: 10px;
                  "
                >
                  <span>{{ item }}</span>
                  <i
                    v-show="isEditting"
                    @click="removeImgae(index, item)"
                    class="el-icon-error iconPosi"
                  ></i>
                </div>
              </div>
            </div>
          </li>
          <li class="exclusive">
            <h4>作者</h4>
            <!-- <p>{{articleDetail.organization_author_map_copy}}</p> -->
            <div style="display: flex; flex-direction: column; font-size: 16px">
              <div
                class="images-box"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div
                  class="image-list"
                  style="display: flex; flex-direction: column"
                >
                  <div
                    class="image-item"
                    v-for="(
                      item, index
                    ) in articleDetail.organization_author_map_copy"
                    :key="index"
                    style="
                      height: 32px;
                      background-color: #5470c6;
                      color: white;
                      text-align: left;
                      border-radius: 5%;
                      line-height: 32px;
                      margin-bottom: 10px;
                      padding-left: 10px;
                    "
                  >
                    作者：<span>{{ item.author }}</span> 所属机构：<span>{{
                      item.organization | scholarname
                    }}</span>
                    <i
                      v-show="isEditting"
                      @click="removeImgae1(index)"
                      class="el-icon-error iconPosi"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="exclusive">
            <h4 class="choice"></h4>
            <button @click="addScholar()" class="buttonn">添加作者</button>
          </li>
          <li class="exclusive">
            <h4>Abstract</h4>
            <el-input
              type="textarea"
              v-if="isEditting"
              :rows="2"
              placeholder="请输入内容"
              v-model="articleDetail.abs"
            >
            </el-input>
          </li>
          <li class="one-third">
            <h4>分类排序</h4>
            <el-input-number v-model="articleDetail.classification_order">
            </el-input-number>
          </li>
          <!-- <li class="one-third">
            <h4>开始时间</h4>
            <el-date-picker
              v-model="articleDetail.start_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </li>
          <li class="one-third">
            <h4>结束时间</h4>
            <el-date-picker
              v-model="articleDetail.end_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </li>
          <li class="half">
            <h4>语言</h4>
            <el-input
              v-model="articleDetail.language"
              placeholder="请输入语言"
            ></el-input>
          </li>
          <li class="half">
            <h4>地点</h4>
            <el-input
              v-model="articleDetail.location"
              placeholder="请输入地点"
            ></el-input>
          </li> -->
          <li class="exclusive">
            <h4>链接</h4>
            <el-input
              v-model="articleDetail.link"
              placeholder="请输入链接"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4 class="choice">history</h4>
            <div class="input" v-if="isEditting">
              <keywordsinput
                :maxLen="40"
                :_key="4"
                v-model="articleDetail.history"
              ></keywordsinput>
            </div>
          </li>
          <li class="exclusive">
            <h4 class="choice">keywords</h4>
            <div class="input" v-if="isEditting">
              <keywordsinput
                :maxLen="40"
                :_key="5"
                v-model="articleDetail.keywords"
              ></keywordsinput>
            </div>
          </li>

          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="articleDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
      <el-dialog
        class="articleDialog"
        :title="articleDetail.title"
        :visible.sync="isUpdateShow"
        width="30%"
      >
        <el-form label-width="80px">
          <el-form-item label="作者">
            <el-input v-model="ArticleDetail.organization_author"></el-input>
          </el-form-item>

          <el-form-item label="机构">
            <el-select
              v-model="ArticleDetail.organization"
              multiple
              placeholder="请选择"
              value-key="index"
            >
              <el-option
                v-for="(item, index) in articleDetail.organization"
                :key="index"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog-footer-button-one"
            @click="isUpdateShow = false"
            >取 消</el-button
          >
          <el-button
            class="dialog-footer-button-second"
            type="primary"
            @click="submitBanner(ArticleDetail)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        class="articleDialog"
        :visible.sync="isUpdateShow1"
        width="30%"
      >
        <el-form label-width="80px">
          <el-form-item label="机构">
            <el-input
              :maxLen="18"
              :_key="6"
              v-model="ArticleDetail1.organization"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog-footer-button-one"
            @click="isUpdateShow1 = false"
            >取 消</el-button
          >
          <el-button
            class="dialog-footer-button-second"
            type="primary"
            @click="submitBanner1(ArticleDetail1)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- <EditContent
      ref="articleDetailAbs"
      :header="'Abs'"
      :content="articleDetail.abs"
      :isEditting="isEditting"
    ></EditContent> -->
    <EditContent
      ref="articleDetailContent"
      :header="'内容'"
      :content="articleDetail.content"
      :isEditting="isEditting"
    ></EditContent>
    <Comment v-if="this.$route.query.id" />
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import UploadImage from "../../componentSet/uploadImage.vue";
import UploadImages from "../university/components/uploadImages.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import MagazineThemeManagement from "./components/MagazineThemeManagement";
import Comment from "./components/Comment.vue";
import EditContent from "../../componentSet/EditContent.vue";
import { getUniversityAddress_Api } from "../../../apis/university.api";
import {
  getArticleDetail_Api,
  setArticleDetail_Api,
  updateArticleDetail_Api,
  // getArticleTopics_Api,
} from "../../../apis/magazine.api";
import SaveGroup from "../../componentSet/SaveGroup.vue";

export default {
  components: {
    SaveGroup,
    UploadImage,
    UploadImages,
    MagazineThemeManagement,
    BreadCrumb,
    Comment,
    EditContent,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        {
          name: "文章列表",
          link: `/admin/newMagazineDetail?id=${this.$route.query.magazine_id}&method=update`,
        },
        {
          name: `${this.articleDetail.title ? this.articleDetail.title : ""}`,
          link: "/admin/newsDetail",
        },
      ];
    },
  },
  data() {
    return {
      isUpdateShow: false,
      isUpdateShow1: false,
      selectedTheme: null,
      isEditting: false,
      ArticleDetail: {
        organization_author: "",
        organization: [],
      },
      ArticleDetail1: {
        organization_author: "",
        organization: "",
      },
      articleDetail: {
        keywords: [],
        history: [],
        id: null,
        organization_author_obj: [],
        organization: [],
        organization_author_map_copy: [],
        classification: { chinese_name: "", english_name: "", id: null },
      },
      content: "",
      addressList: [],
      articleClassificationList: [],
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.articleDetail.id = this.$route.query.id;

      this.getMagazineDetail();
    } else {
      this.isEditting = true;
    }
    // getArticleTopics_Api().then((res) => {
    //   this.articleClassificationList = res.data;
    // });
  },
  filters: {
    scholarname: function (value) {
      for (let i in value) {
        return value.toString();
      }
    },
  },
  methods: {
    addScholar() {
      this.isUpdateShow = true;
      this.ArticleDetail = {
        organization_author: "",
        organization: [],
      };
    },
    submitBanner1(item) {
      console.log(item);
      this.isUpdateShow1 = false;
      this.articleDetail.organization.push(this.ArticleDetail1.organization);
    },
    submitBanner(item) {
      console.log(item);
      this.isUpdateShow = false;
      console.log(this.ArticleDetail);
      console.log(this.articleDetail);
      // var param = {};
      // let key = this.ArticleDetail.organization_author;
      // let value = this.ArticleDetail.organization;
      // param[key] = value;
      // console.log(this.articleDetail.organization_author_obj);
      // param.index = this.articleDetail.organization_author_map.length;
      // this.articleDetail.organization_author_obj.push(param);
      // console.log(this.articleDetail.organization_author_obj);
      this.articleDetail.organization_author_map_copy.push({
        author: this.ArticleDetail.organization_author,
        organization: this.ArticleDetail.organization,
      });
    },
    addOrganization() {
      this.isUpdateShow1 = true;
      this.ArticleDetail1 = {
        organization_author: "",
        organization: "",
      };
    },
    getUploadCoverImage(img_url) {
      this.articleDetail.cover_image = img_url;
    },
    getUploadQrcode(img_url) {
      this.articleDetail.qr_code = img_url;
    },

    removeImgae(index, content) {
      let test = 0;
      this.articleDetail.organization_author_map_copy.forEach((item) => {
        item.organization.forEach((item) => {
          if (item == content) {
            test = 1;
          }
        });
      });
      if (test == 1) {
        this.$global.error(this, "请先移除和该机构相关的作者", null);
      } else {
        this.articleDetail.organization.splice(index, 1);
      }
      console.log(this.articleDetail.organization_author_map_copy);
    },
    removeImgae1(index) {
      this.articleDetail.organization_author_map_copy.splice(index, 1);
      this.articleDetail.organization_author_map.splice(index, 1);
    },

    getMagazineDetail(hint) {
      getArticleDetail_Api(this.articleDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        res.data.organization_author_map_copy = [];
        if (res.data.organization_author_map.length != 0) {
          res.data.organization_author_map.forEach((element) => {
            for (let key in element) {
              if (key != "index") {
                res.data.organization_author_map_copy.push({
                  author: key,
                  organization: element[key],
                });
              }
            }
          });
        }
        this.articleDetail = res.data;
        console.log(this.articleDetail);
        if (!this.articleDetail.title == null) {
          this.articleDetail.title = "";
        }
        if (!this.articleDetail.introduce == null) {
          this.articleDetail.introduce = "";
        }
        console.log(this.articleDetail);
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getMagazineDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getMagazineDetail("恢复成功");
    },
    view() {
      window.open(
        "http://guihua.wupen.org/article?id=" +
          this.$route.query.id +
          "&magazineId=" +
          this.$route.query.magazine_id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.articleDetail);
      this.articleDetail.magazine_classification_id = this.$route.query.magazine_classification_id;
      if (!formattedData) {
        return;
      } else {
        setArticleDetail_Api(formattedData)
          .then((res) => {
            this.articleDetail = res.data;
            this.isEditting = false;
            this.getMagazineDetail();
            this.$router.push({
              path: "/admin/MagazineArticleDetail",
              query: {
                id: res.data.id,
                method: "update",
                content_type: "article",
                magazine_id: this.$route.query.magazine_id,
              },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.articleDetail);
      // this.organization_author_obj = this.organization_author_map
      if (!formattedData) {
        return;
      } else {
        updateArticleDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getMagazineDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      // if (!formData.start_time || !formData.end_time) {
      //   this.$global.error(this, "请输入起始时间");
      //   return false;
      // }

      // formData.image_list = formData.images;
      // formData.organization_author_obj = formData.organization_author_obj;

      if (formData.organization_author_map_copy.length != 0) {
        formData.organization_author_obj = [];
        formData.organization_author_map_copy.forEach((element, index) => {
          let param2 = {};
          let key = element.author;
          let value = element.organization;
          param2[key] = value.map((item) => item.replaceAll(",", ";"));
          param2.index = index;
          formData.organization_author_obj.push(param2);
        });
      }
      console.log(formData.organization_author_map_copy);
      formData.article_id = formData.id;
      if (formData.organization) {
        formData.organization_list = formData.organization.map((item) =>
          item.replaceAll(",", ";")
        );
      }
      if (formData.classification) {
        formData.classification_id = formData.classification.id;
      }
      if (!formData.end_time) {
        delete formData.end_time;
      }
      if (!formData.start_time) {
        delete formData.start_time;
      }
      // formData.abs = this.$refs.articleDetailAbs.getContent();
      formData.content = this.$refs.articleDetailContent.getContent();
      formData.keywords_list = formData.keywords;
      formData.history_list = formData.history;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.org_author {
  margin-right: 20px;
}
.university-images {
  @include box-model;
  .images-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      .image-item {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        img {
          height: 140px;
        }
        .el-icon-error {
          color: $base-color;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 0;
          cursor: pointer;
        }
      }
      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
.form-content .logo {
  width: 150px;
  height: 200px !important;
}
.form-content .cover {
  width: 220px;
  height: 120px;
}
.form-content .logo {
  width: 150px;
  height: 120px;
}
.buttonn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  -o-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.image-item {
  .el-icon-error {
    cursor: pointer;
    float: right;
    line-height: 100%;
    margin: 10px 5px 0 5px;
  }
}
/deep/ .pc-isDetail-detail {
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/guihua/MagazineArticleDetail.vue